__turbopack_context__.v({
  "partners-scroll": "Mi7JyG_partners-scroll",
  "track": "Mi7JyG_track",
  "wrapper": "Mi7JyG_wrapper",
});
